import type { AxiosInstance } from 'axios';
import type { GetGroupFileTags, GetGroupFolderTags, GetGroupTranscriptTags, GetProjectParentTags, GetQuantAnalysisItemTags, MassAddObjectTags, UpdateGroupFileTags, UpdateGroupFolderTags, UpdateGroupTranscriptTags, UpdateProjectParentTags, UpdateQuantAnalysisItemTags } from './interfaces/tags';

export class TagsClient {
  constructor(private authenticatedClient: AxiosInstance) { }

  massAddObjectTags = async (params: MassAddObjectTags.Params): Promise<MassAddObjectTags.Response> => {
    const response = await this.authenticatedClient.post<MassAddObjectTags.Response>('/tags/mass-add-object-tags', params);
    return response.data;
  };

  getProjectParentTags = async (params: { projectParentId: number }): Promise<GetProjectParentTags.Response> => {
    const response = await this.authenticatedClient.get<GetProjectParentTags.Response>(`/tags/project-parents/${params.projectParentId}`);
    return response.data;
  };

  updateProjectParentTags = async ({ projectParentId, ...payload }: UpdateProjectParentTags.Request) => {
    return this.authenticatedClient.put<UpdateProjectParentTags.Response>(`/tags/project-parents/${projectParentId}`, payload);
  };

  getTranscriptTags = async ({ transcriptId }: GetGroupTranscriptTags.Request) => {
    const response = await this.authenticatedClient.get<GetGroupTranscriptTags.Response>(`/tags/transcript/${transcriptId}`);
    return response.data;
  };

  updateTranscriptTags = async ({ transcriptId, ...payload }: UpdateGroupTranscriptTags.Request) => {
    return this.authenticatedClient.put<UpdateGroupTranscriptTags.Response>(`/tags/transcript/${transcriptId}`, payload);
  };

  getFolderTags = async ({ folderId }: GetGroupFolderTags.Request) => {
    const response = await this.authenticatedClient.get<GetGroupFolderTags.Response>(`/tags/folder/${folderId}`);
    return response.data;
  };

  updateFolderTags = async ({ folderId, ...payload }: UpdateGroupFolderTags.Request) => {
    return this.authenticatedClient.put<UpdateGroupFolderTags.Response>(`/tags/folder/${folderId}`, payload);
  };

  getFileTags = async ({ fileId }: GetGroupFileTags.Request) => {
    const response = await this.authenticatedClient.get<GetGroupFileTags.Response>(`/tags/file/${fileId}`);
    return response.data;
  };

  updateFileTags = async ({ fileId, ...payload }: UpdateGroupFileTags.Request) => {
    return this.authenticatedClient.put<UpdateGroupFileTags.Response>(`/tags/file/${fileId}`, payload);
  };

  getQuantAnalysisItemTags = async ({ itemId }: GetQuantAnalysisItemTags.Request) => {
    const response = await this.authenticatedClient.get<GetQuantAnalysisItemTags.Response>(`/tags/quant-analysis/${itemId}`);
    return response.data;
  };

  updateQuantAnalysisItemTags = async ({ itemId, ...payload }: UpdateQuantAnalysisItemTags.Request) => {
    return this.authenticatedClient.put<UpdateQuantAnalysisItemTags.Response>(`/tags/quant-analysis/${itemId}`, payload);
  };
}

export default TagsClient;
